/* @flow */

export const validation = {
  headingMaxChar: 100,
  paragraphMaxChar: 100,
  contentParagraphMaxChar: 1000,
  bottomBlockTitleMaxChar: 100,
  bottomBlockParagraphMaxChar: 100,
}
